const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://gad-alchemist-api.backtrue.workers.dev';

export async function apiRequest(endpoint: string, options: RequestInit = {}) {
    const token = localStorage.getItem('auth_token');
    
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        ...(options.headers as Record<string, string>),
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        ...options,
        headers,
    });

    // Si retorna 401, significa que el token ha expirat
    if (response.status === 401) {
        localStorage.removeItem('auth_token');
        window.location.href = '/login';
        throw new Error('Session expired');
    }

    return response;
}

// Helper functions
export async function apiGet(endpoint: string) {
    return apiRequest(endpoint, { method: 'GET' });
}

export async function apiPost(endpoint: string, data?: any) {
    return apiRequest(endpoint, {
        method: 'POST',
        body: data ? JSON.stringify(data) : undefined,
    });
}

export async function apiPatch(endpoint: string, data?: any) {
    return apiRequest(endpoint, {
        method: 'PATCH',
        body: data ? JSON.stringify(data) : undefined,
    });
}

export async function apiDelete(endpoint: string) {
    return apiRequest(endpoint, { method: 'DELETE' });
}

// Mantenir compatibilitat amb codi existent
export const API_URL = API_BASE_URL;
